import React from "react";
import InputField from "./InputField";
import SubmitButton from "./SubmitButton";
import UserStore from "../../stores/UserStore";
import { Link } from "react-router-dom";
import { DropdownList, Multiselect } from "react-widgets";
import Can from "../authentication/Can";
import { alertService } from "../common/alert.service";
import { emailValidate, phoneValidate } from "../common/inputValidationHelpers";
import { Box, Grid } from "@material-ui/core";
import TextBox from "./TextBox";
import Table from "./ReactTable";

class SearchResults extends React.Component {
    constructor(props) {
      super(props);
      this._isMounted = false;
      this.state = {
        searchResults: props.searchResults,
        resultsColumns: [
          {
            Header: "Work Order Number",
            accessor: "wONum",
          },
          {
            Header: "SKU",
            accessor: "SKU",
          },
          {
            Header: "S/N",
            accessor: "sN",
          },
          {
            Header: "REF",
            accessor: "rO",
          },
        ],
      };
      
      this.handleInputChange = this.handleInputChange.bind(this);
    }
  
    async componentDidMount() {
      this._isMounted = true;
    }

    async componentWillUnmount() {
      this._isMounted = false;
    }

    setInputValue(property, val) {
      this._isMounted && this.setState(
        {
          [property]: val,
        },
      );
    }
    
    handleInputChange(event){
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;

      this._isMounted && this.setState(
        {
          [name]: value,
        },
        () => {}
      );
    }

    render() {
      return (
        <Box justifyContent="space-around" display="flex" flexDirection="column">
          <Table
            columns={this.state.resultsColumns}
            data={this.state.searchResults?this.state.searchResults:[]}
            getRowProps={(row) => ({
              className: "clickable",
              onClick: () => {
              },
            })}
          />
        </Box>
      );
    }
  }
  
  export default SearchResults;  